module.exports = __webpack_public_path__ + "img/plan-2-b2.c742ce3c.png";